import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [
  carouselLogos.CHIME,
  carouselLogos.VACASA,
  carouselLogos.INTUIT,
  carouselLogos.IBM,
  carouselLogos.DELIVEROO,
]

const copy = {
  description: `Trusted by startups and the world's largest companies`,
}

const LogoCarousel = () => (
  <StyledSection variant="noCopy">
    <Section.Contents>
      <LogoCarouselTemplate logos={logos} heading={copy.description} />
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding: 64px 40px;
    }
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding: 64px 80px;
    }
  }
`

export default LogoCarousel
